import { type FC } from "react";

import { FeatureGuard } from "../../cof-feature-gates/components";
import { CofConfigId } from "../../gql-generated/types";

import { AssistantChatDrawer } from "./AssistantChatDrawer";
import { AssistantChatFab } from "./AssistantChatFab";

export const AssistantChatContainer: FC = () => (
    <FeatureGuard cofConfigId={CofConfigId.MyLensesChat}>
        <AssistantChatFab />
        <AssistantChatDrawer />
    </FeatureGuard>
);
